<div class="confirm-dialog" [class.confirm-dialog--fit-content]="fitContent">
    <div class="dialog-content">
        <div class="dlg-msg" [innerHTML]="config.data.message"></div>
        <div class="confirm-btn" *ngIf = "isOkCancel">
            <caremoni-button class="cancel-btn" (click) = "closeModal()" [buttonText]="BUTTON.NO"
                [cssCustom]="cssCustom"
                [dpad]="DpadZoneType.DIALOG"
                [xdpad]="0"
                [ydpad]="0"
                [scaledpad]="1.05">
            </caremoni-button>
            <caremoni-button class="ok-btn" (click) = "onSubmit()" [buttonText]="BUTTON.YES"
                [cssCustom]="cssCustom"
                [dpad]="DpadZoneType.DIALOG"
                [xdpad]="1"
                [ydpad]="0"
                [scaledpad]="1.05">
            </caremoni-button>
        </div>
        <div class="confirm-btn" *ngIf = "!isOkCancel">
            <caremoni-button class="ok-btn" (click) = "closeModal()" [buttonText]="BUTTON.CLOSE">
            </caremoni-button>
        </div>
    </div>
</div>